var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroSection'),_c('WhyErudio'),_c('AprendizadoMao'),_c('SimpleManagement'),_c('WantToTry')],1)}
var staticRenderFns = []

export { render, staticRenderFns }